import { fetchIPERC } from "../http-common";

const postListarComboEquipo = (
  data: any,
  constroller = new AbortController()
) => {
  return fetchIPERC.post(`Equipo/ListarComboEquipo`, data, {
    signal: constroller.signal,
  });
};

const postListarTablaEquipo = (
  filter: any,
  constroller = new AbortController()
) => {
  return fetchIPERC.post(`Equipo/ListarTableEquipos`, filter, {
    signal: constroller.signal,
  });
};

const postActualizarNombreEquipo = (
  data: any,
) => {
  return fetchIPERC.post(`Equipo/ActualizarNombre`, data);
};



const postCrearEquipoIperc = (
  data: any,
) => {
  return fetchIPERC.post(`Equipo/Crear`, data);
};

const EquipoService = {
  postListarComboEquipo,
  postListarTablaEquipo,
  postActualizarNombreEquipo,
  postCrearEquipoIperc,
};

export default EquipoService;
